module.exports = __webpack_public_path__ + "img/fr.3c59a185.svg";